import type { RenderDoc, RendererProps, RenderFn } from './types';

let renderFunction: RenderFn | null = null;
let hasOverridesForRendering: boolean | undefined;

export function setRenderer(fn: RenderFn) {
  renderFunction = fn;
}

export function renderStructuredContent(
  doc: RenderDoc,
  rendererProps?: RendererProps,
  hasOverrides?: boolean,
) {
  if (!renderFunction) {
    throw new Error(
      'Renderer was not initialized. Call setRenderer() first before calling renderStructuredContent()',
    );
  }

  if (hasOverrides !== undefined) {
    hasOverridesForRendering = hasOverrides;
  }

  return renderFunction({ doc, rendererProps, hasOverrides: hasOverridesForRendering });
}
